// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Definition — maps a bit/byte position within an offset to a
 * human-readable message with severity and alert configuration.
 */
export class Definition implements flatbuffers.IUnpackableObject<DefinitionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Definition {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDefinition(bb: flatbuffers.ByteBuffer, obj?: Definition): Definition {
    return (obj || new Definition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDefinition(bb: flatbuffers.ByteBuffer, obj?: Definition): Definition {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Definition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  offsetTypeId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  specialDefinitionId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  helpId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  message(): string | null;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  message(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  shortMessage(): string | null;
  shortMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  shortMessage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  severity(): string | null;
  severity(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  severity(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  group(): string | null;
  group(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  group(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  groupName(): string | null;
  groupName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  groupName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  pointName(): string | null;
  pointName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  pointName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  specialSwitchName(): string | null;
  specialSwitchName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  specialSwitchName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  thirdPartyPosition(): string | null;
  thirdPartyPosition(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  thirdPartyPosition(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  bit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  byte(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
  }

  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  pagingScheme(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  confirmSeconds(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  activePosition(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  alert(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  log(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  isClone(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startDefinition(builder: flatbuffers.Builder) {
    builder.startObject(25);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOffsetTypeId(builder: flatbuffers.Builder, offsetTypeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, offsetTypeIdOffset, 0);
  }

  static addSpecialDefinitionId(
    builder: flatbuffers.Builder,
    specialDefinitionIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, specialDefinitionIdOffset, 0);
  }

  static addHelpId(builder: flatbuffers.Builder, helpIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, helpIdOffset, 0);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, messageOffset, 0);
  }

  static addShortMessage(builder: flatbuffers.Builder, shortMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, shortMessageOffset, 0);
  }

  static addSeverity(builder: flatbuffers.Builder, severityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, severityOffset, 0);
  }

  static addGroup(builder: flatbuffers.Builder, groupOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, groupOffset, 0);
  }

  static addGroupName(builder: flatbuffers.Builder, groupNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, groupNameOffset, 0);
  }

  static addPointName(builder: flatbuffers.Builder, pointNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, pointNameOffset, 0);
  }

  static addSpecialSwitchName(
    builder: flatbuffers.Builder,
    specialSwitchNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, specialSwitchNameOffset, 0);
  }

  static addThirdPartyPosition(
    builder: flatbuffers.Builder,
    thirdPartyPositionOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(11, thirdPartyPositionOffset, 0);
  }

  static addBit(builder: flatbuffers.Builder, bit: number) {
    builder.addFieldInt32(12, bit, 0);
  }

  static addByte(builder: flatbuffers.Builder, byte: number) {
    builder.addFieldInt32(13, byte, 0);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(14, value, 1);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt32(15, priority, 0);
  }

  static addPagingScheme(builder: flatbuffers.Builder, pagingScheme: number) {
    builder.addFieldInt32(16, pagingScheme, 0);
  }

  static addConfirmSeconds(builder: flatbuffers.Builder, confirmSeconds: number) {
    builder.addFieldInt32(17, confirmSeconds, 0);
  }

  static addActivePosition(builder: flatbuffers.Builder, activePosition: boolean) {
    builder.addFieldInt8(18, +activePosition, +false);
  }

  static addAlert(builder: flatbuffers.Builder, alert: boolean) {
    builder.addFieldInt8(19, +alert, +false);
  }

  static addLog(builder: flatbuffers.Builder, log: boolean) {
    builder.addFieldInt8(20, +log, +false);
  }

  static addIsClone(builder: flatbuffers.Builder, isClone: boolean) {
    builder.addFieldInt8(21, +isClone, +false);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(22, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(24, deletedAtOffset, 0);
  }

  static endDefinition(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): DefinitionT {
    return new DefinitionT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null,
      this.specialDefinitionId() !== null ? this.specialDefinitionId()!.unpack() : null,
      this.helpId() !== null ? this.helpId()!.unpack() : null,
      this.message(),
      this.shortMessage(),
      this.severity(),
      this.group(),
      this.groupName(),
      this.pointName(),
      this.specialSwitchName(),
      this.thirdPartyPosition(),
      this.bit(),
      this.byte(),
      this.value(),
      this.priority(),
      this.pagingScheme(),
      this.confirmSeconds(),
      this.activePosition(),
      this.alert(),
      this.log(),
      this.isClone(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: DefinitionT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.offsetTypeId = this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null;
    _o.specialDefinitionId =
      this.specialDefinitionId() !== null ? this.specialDefinitionId()!.unpack() : null;
    _o.helpId = this.helpId() !== null ? this.helpId()!.unpack() : null;
    _o.message = this.message();
    _o.shortMessage = this.shortMessage();
    _o.severity = this.severity();
    _o.group = this.group();
    _o.groupName = this.groupName();
    _o.pointName = this.pointName();
    _o.specialSwitchName = this.specialSwitchName();
    _o.thirdPartyPosition = this.thirdPartyPosition();
    _o.bit = this.bit();
    _o.byte = this.byte();
    _o.value = this.value();
    _o.priority = this.priority();
    _o.pagingScheme = this.pagingScheme();
    _o.confirmSeconds = this.confirmSeconds();
    _o.activePosition = this.activePosition();
    _o.alert = this.alert();
    _o.log = this.log();
    _o.isClone = this.isClone();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): DefinitionT {
    const t = new DefinitionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("offset_type_id")) {
      t.offsetTypeId = this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null;
    }
    if (fieldSet.has("special_definition_id")) {
      t.specialDefinitionId =
        this.specialDefinitionId() !== null ? this.specialDefinitionId()!.unpack() : null;
    }
    if (fieldSet.has("help_id")) {
      t.helpId = this.helpId() !== null ? this.helpId()!.unpack() : null;
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("short_message")) {
      t.shortMessage = this.shortMessage();
    }
    if (fieldSet.has("severity")) {
      t.severity = this.severity();
    }
    if (fieldSet.has("group")) {
      t.group = this.group();
    }
    if (fieldSet.has("group_name")) {
      t.groupName = this.groupName();
    }
    if (fieldSet.has("point_name")) {
      t.pointName = this.pointName();
    }
    if (fieldSet.has("special_switch_name")) {
      t.specialSwitchName = this.specialSwitchName();
    }
    if (fieldSet.has("third_party_position")) {
      t.thirdPartyPosition = this.thirdPartyPosition();
    }
    if (fieldSet.has("bit")) {
      t.bit = this.bit();
    }
    if (fieldSet.has("byte")) {
      t.byte = this.byte();
    }
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("paging_scheme")) {
      t.pagingScheme = this.pagingScheme();
    }
    if (fieldSet.has("confirm_seconds")) {
      t.confirmSeconds = this.confirmSeconds();
    }
    if (fieldSet.has("active_position")) {
      t.activePosition = this.activePosition();
    }
    if (fieldSet.has("alert")) {
      t.alert = this.alert();
    }
    if (fieldSet.has("log")) {
      t.log = this.log();
    }
    if (fieldSet.has("is_clone")) {
      t.isClone = this.isClone();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class DefinitionT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public offsetTypeId: UuidT | null = null,
    public specialDefinitionId: UuidT | null = null,
    public helpId: UuidT | null = null,
    public message: string | Uint8Array | null = null,
    public shortMessage: string | Uint8Array | null = null,
    public severity: string | Uint8Array | null = null,
    public group: string | Uint8Array | null = null,
    public groupName: string | Uint8Array | null = null,
    public pointName: string | Uint8Array | null = null,
    public specialSwitchName: string | Uint8Array | null = null,
    public thirdPartyPosition: string | Uint8Array | null = null,
    public bit: number = 0,
    public byte: number = 0,
    public value: number = 1,
    public priority: number = 0,
    public pagingScheme: number = 0,
    public confirmSeconds: number = 0,
    public activePosition: boolean = false,
    public alert: boolean = false,
    public log: boolean = false,
    public isClone: boolean = false,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const offsetTypeId = this.offsetTypeId !== null ? this.offsetTypeId!.pack(builder) : 0;
    const specialDefinitionId =
      this.specialDefinitionId !== null ? this.specialDefinitionId!.pack(builder) : 0;
    const helpId = this.helpId !== null ? this.helpId!.pack(builder) : 0;
    const message = this.message !== null ? builder.createString(this.message!) : 0;
    const shortMessage = this.shortMessage !== null ? builder.createString(this.shortMessage!) : 0;
    const severity = this.severity !== null ? builder.createString(this.severity!) : 0;
    const group = this.group !== null ? builder.createString(this.group!) : 0;
    const groupName = this.groupName !== null ? builder.createString(this.groupName!) : 0;
    const pointName = this.pointName !== null ? builder.createString(this.pointName!) : 0;
    const specialSwitchName =
      this.specialSwitchName !== null ? builder.createString(this.specialSwitchName!) : 0;
    const thirdPartyPosition =
      this.thirdPartyPosition !== null ? builder.createString(this.thirdPartyPosition!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    Definition.startDefinition(builder);
    Definition.addId(builder, id);
    Definition.addOffsetTypeId(builder, offsetTypeId);
    Definition.addSpecialDefinitionId(builder, specialDefinitionId);
    Definition.addHelpId(builder, helpId);
    Definition.addMessage(builder, message);
    Definition.addShortMessage(builder, shortMessage);
    Definition.addSeverity(builder, severity);
    Definition.addGroup(builder, group);
    Definition.addGroupName(builder, groupName);
    Definition.addPointName(builder, pointName);
    Definition.addSpecialSwitchName(builder, specialSwitchName);
    Definition.addThirdPartyPosition(builder, thirdPartyPosition);
    Definition.addBit(builder, this.bit);
    Definition.addByte(builder, this.byte);
    Definition.addValue(builder, this.value);
    Definition.addPriority(builder, this.priority);
    Definition.addPagingScheme(builder, this.pagingScheme);
    Definition.addConfirmSeconds(builder, this.confirmSeconds);
    Definition.addActivePosition(builder, this.activePosition);
    Definition.addAlert(builder, this.alert);
    Definition.addLog(builder, this.log);
    Definition.addIsClone(builder, this.isClone);
    Definition.addCreatedAt(builder, createdAt);
    Definition.addUpdatedAt(builder, updatedAt);
    Definition.addDeletedAt(builder, deletedAt);

    return Definition.endDefinition(builder);
  }

  clone(): DefinitionT {
    const obj = new DefinitionT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.offsetTypeId = this.offsetTypeId !== null ? this.offsetTypeId!.clone() : null;
    obj.specialDefinitionId =
      this.specialDefinitionId !== null ? this.specialDefinitionId!.clone() : null;
    obj.helpId = this.helpId !== null ? this.helpId!.clone() : null;
    obj.message = this.message;
    obj.shortMessage = this.shortMessage;
    obj.severity = this.severity;
    obj.group = this.group;
    obj.groupName = this.groupName;
    obj.pointName = this.pointName;
    obj.specialSwitchName = this.specialSwitchName;
    obj.thirdPartyPosition = this.thirdPartyPosition;
    obj.bit = this.bit;
    obj.byte = this.byte;
    obj.value = this.value;
    obj.priority = this.priority;
    obj.pagingScheme = this.pagingScheme;
    obj.confirmSeconds = this.confirmSeconds;
    obj.activePosition = this.activePosition;
    obj.alert = this.alert;
    obj.log = this.log;
    obj.isClone = this.isClone;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: DefinitionT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.offsetTypeId !== null && other.offsetTypeId !== null) {
      if (!this.offsetTypeId!.equals(other.offsetTypeId!)) return false;
    } else if (this.offsetTypeId !== other.offsetTypeId) return false;
    if (this.specialDefinitionId !== null && other.specialDefinitionId !== null) {
      if (!this.specialDefinitionId!.equals(other.specialDefinitionId!)) return false;
    } else if (this.specialDefinitionId !== other.specialDefinitionId) return false;
    if (this.helpId !== null && other.helpId !== null) {
      if (!this.helpId!.equals(other.helpId!)) return false;
    } else if (this.helpId !== other.helpId) return false;
    if (this.message !== other.message) return false;
    if (this.shortMessage !== other.shortMessage) return false;
    if (this.severity !== other.severity) return false;
    if (this.group !== other.group) return false;
    if (this.groupName !== other.groupName) return false;
    if (this.pointName !== other.pointName) return false;
    if (this.specialSwitchName !== other.specialSwitchName) return false;
    if (this.thirdPartyPosition !== other.thirdPartyPosition) return false;
    if (this.bit !== other.bit) return false;
    if (this.byte !== other.byte) return false;
    if (this.value !== other.value) return false;
    if (this.priority !== other.priority) return false;
    if (this.pagingScheme !== other.pagingScheme) return false;
    if (this.confirmSeconds !== other.confirmSeconds) return false;
    if (this.activePosition !== other.activePosition) return false;
    if (this.alert !== other.alert) return false;
    if (this.log !== other.log) return false;
    if (this.isClone !== other.isClone) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyDefinition(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 4);
    verifier.checkScalarField(tablePos, 36, 4);
    verifier.checkScalarField(tablePos, 38, 4);
    verifier.checkScalarField(tablePos, 40, 1);
    verifier.checkScalarField(tablePos, 42, 1);
    verifier.checkScalarField(tablePos, 44, 1);
    verifier.checkScalarField(tablePos, 46, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
